import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';

export const RunsOptions: ITaggingFlowOption[] = [
  {
    displayName: 'No Runs',
    value: 0,
    hotkeyCode: 48,
    hotkeyDisplay: '0',
  },
  {
    displayName: '1 Run',
    value: 1,
    hotkeyCode: 49,
    hotkeyDisplay: '1',
  },
  {
    displayName: '2 Runs',
    value: 2,
    hotkeyCode: 50,
    hotkeyDisplay: '2',
  },
  {
    displayName: '3 Runs',
    value: 3,
    hotkeyCode: 51,
    hotkeyDisplay: '3',
  },
  {
    displayName: '4 Runs',
    value: 4,
    hotkeyCode: 52,
    hotkeyDisplay: '4',
  },
];
